module.exports = __webpack_public_path__ + "static/media/18.afe750cc.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/files/18.jpeg
// module id = 85
// module chunks = 0